
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import { EnumProductType } from '@xt/client/enums/my/index'

@Observer
@Component({
  components: {
    Title,
    LazyImg,
    HeaderImage
  }
})
export default class MyAccount extends Vue {
  accountBackgroundImgList: string[] = [
    this.$images.my_classroom_order,
    this.$images.my_classroom_coupon,
    this.$images.my_classroom_exchange
  ]

  get EnumProductType() {
    return EnumProductType
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
